import { useCallback } from 'react';
import ChevronLeftSolid from '@simplywallst/ui-core/icons/ChevronLeftSolid';
import ChevronLeftEndSolid from '@simplywallst/ui-core/icons/ChevronLeftEndSolid';
import {
  NextPages,
  PageCount,
  PageLink,
  PaginationWrapper,
  PrevPages,
  PaginationRow,
} from './styled';

interface RouterLinkAction {
  type: string;
  payload?: any;
}

interface Props {
  totalPages: number;
  currentPage: number;
  actionLink: (number) => string | RouterLinkAction;
  loading?: boolean;
  styleType?: 'light' | 'dark';
}

export const Pagination = ({
  currentPage,
  totalPages,
  actionLink,
  loading,
  styleType = 'dark',
}: Props) => {
  const handleBackToTop = useCallback(
    () =>
      window.scrollTo({
        top: 0,
        left: 0,
      }),
    []
  );
  const disableLeft =
    currentPage === 1 ||
    currentPage < 1 ||
    totalPages === 0 ||
    loading === true;
  const disableRight =
    currentPage === totalPages ||
    currentPage > totalPages ||
    totalPages === 0 ||
    loading === true;

  return (
    <PaginationWrapper styleType={styleType}>
      <PaginationRow justifyContent="space-between" data-cy-id="pagination">
        <PrevPages styleType={styleType} disabled={disableLeft}>
          {disableLeft ? (
            <>
              <ChevronLeftEndSolid data-cy-id="disabled-first" />
              <ChevronLeftSolid data-cy-id="disabled-prev" />
            </>
          ) : (
            <>
              <PageLink
                to={actionLink(1)}
                onClick={handleBackToTop}
                data-cy-id="first"
              >
                <ChevronLeftEndSolid />
              </PageLink>
              <PageLink
                to={actionLink(currentPage - 1)}
                onClick={handleBackToTop}
                data-cy-id="prev"
              >
                <ChevronLeftSolid />
              </PageLink>
            </>
          )}
        </PrevPages>
        <PageCount
          styleType={styleType}
          data-cy-id="count"
        >{`Page ${currentPage} of ${totalPages}`}</PageCount>
        <NextPages styleType={styleType} disabled={disableRight}>
          {disableRight ? (
            <>
              <ChevronLeftSolid data-cy-id="disabled-next" />
              <ChevronLeftEndSolid data-cy-id="disabled-last" />
            </>
          ) : (
            <>
              <PageLink
                to={actionLink(currentPage + 1)}
                onClick={handleBackToTop}
                data-cy-id="next"
              >
                <ChevronLeftSolid />
              </PageLink>
              <PageLink
                to={actionLink(totalPages)}
                onClick={handleBackToTop}
                data-cy-id="last"
              >
                <ChevronLeftEndSolid />
              </PageLink>
            </>
          )}
        </NextPages>
      </PaginationRow>
    </PaginationWrapper>
  );
};
